import classes from "./BottomNav.module.css";
import { Link } from "react-scroll";

const BottomNav = () => {
  return (
    <div className={classes.bottom}>
      <Link to="home" spy={true} smooth={true} offset={0} duration={1500}>
        <i class="fas fa-home fa-2xl"></i>
      </Link>
      <Link to="about" spy={true} smooth={true} offset={0} duration={1500}>
        <i class="fas fa-user fa-2xl "></i>
      </Link>
      <Link to="skill" spy={true} smooth={true} offset={0} duration={1500}>
        <i class="fas fa-hammer fa-2xl"></i>
      </Link>
      <Link to="services" spy={true} smooth={true} offset={0} duration={1500}>
        <i class="fas fa-star fa-2xl"></i>
      </Link>
      <Link to="contacts" spy={true} smooth={true} offset={0} duration={1500}>
        <i class="fas fa-phone fa-2xl"></i>
      </Link>
    </div>
  );
};

export default BottomNav;
